import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { unwrapResult } from "@reduxjs/toolkit";

import { errorNormalizer } from "../../../../shared/Helpers/functions";
import { CustomButton } from "../../../../shared/uiComponents";
import { AdminTypes } from "../../../../components/Menu";
import { useResetCalendarData } from "../../Helpers/hooks";
import { SessionInfoButtonsWrapper } from "./sessionDate";
import DeleteSession from "./deleteSession";

import { DispatchProperties, useSelector } from "../../../../redux/store";
import { startEventSession } from "../../../../redux/State/clientSlice/sessionSlice";
import {
  getEvents,
  setInfoEvent,
  setInfoEventData,
} from "../../../../redux/State/clientSlice/calendarSlice";

const meetAndGreetSessionTypeIds = [7, 8];

const SessionActions = () => {
  const dispatch = useDispatch<DispatchProperties>();
  const navigate = useNavigate();
  const { resetData } = useResetCalendarData();

  const [loading, setLoading] = useState<boolean>(false);

  const role = useSelector((state) => state.account.role);
  const days = useSelector((state) => state.calendar.displayedCalendarPageDays);
  const data = useSelector((state) => state.calendar.infoEventData);

  const isAdmin = !!role && role.section.id === AdminTypes.admin;
  const isBT = !!role && role.section.id === AdminTypes.bt;

  const canSkipSession =
    (!!data && meetAndGreetSessionTypeIds.includes(data.sessionType.id)) || !isBT;

  const collectDataHandler = () => {
    if (!data) return;
    const { sessionId, client } = data;
    resetData();
    navigate(`/calendar/session/${sessionId}/${client.id}`);
  };

  const startSessionHandler = () => {
    if (!data || !data.id) return;
    setLoading(true);
    dispatch(startEventSession(data.id))
      .then(unwrapResult)
      .then((response) => {
        if (!response.id || !response.client.id || !days.length) return;
        dispatch(setInfoEventData(response));
        const clientId = data.client.id;
        const userId = data.user.id;
        dispatch(getEvents({ days, clientId, userId }));

        if (!canSkipSession) {
          dispatch(setInfoEvent(false));
          navigate(`/calendar/session/${response.id}/${response.client.id}`);
        }
      })
      .catch(errorNormalizer)
      .finally(() => setLoading(false));
  };

  return (
    <SessionInfoButtonsWrapper>
      {!!data && !data.isCompleted ? (
        !!data.sessionId ? (
          <CustomButton title="Collect Data" secondaryButton onClick={collectDataHandler} />
        ) : (
          <CustomButton
            title={canSkipSession ? "Collect Data" : "Start Session"}
            onClick={startSessionHandler}
            loading={loading}
            secondaryButton={canSkipSession}
          />
        )
      ) : (
        <CustomButton title="Session Ended" disabled={!isAdmin} onClick={collectDataHandler} />
      )}
      <DeleteSession />
    </SessionInfoButtonsWrapper>
  );
};

export default SessionActions;
